/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/sara-select/sara-select.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import10 from '@ngx-translate/core/src/translate.pipe';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import13 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import14 from '@angular/core/src/linker/element_ref';
import * as import15 from '@ngx-translate/core/src/translate.service';
import * as import16 from '@angular/common/src/directives/ng_class';
import * as import17 from '../../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import18 from '../../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import19 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import20 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import21 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import23 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import24 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import25 from '@angular/core/src/linker/template_ref';
import * as import26 from '@angular/common/src/directives/ng_if';
import * as import27 from '@angular/common/src/directives/ng_for';
import * as import28 from '@angular/forms/src/directives/control_value_accessor';
import * as import29 from '@angular/forms/src/directives/ng_model';
import * as import30 from '@angular/forms/src/directives/ng_control';
import * as import31 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_SaraSelectComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SaraSelectComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  subscription0:any;
  constructor() {
    this._changed = false;
    this.context = new import0.SaraSelectComponent();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_error(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.error = currValue;
      this._expr_0 = currValue;
    }
  }
  check_name(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.name = currValue;
      this._expr_1 = currValue;
    }
  }
  check_default(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.default = currValue;
      this._expr_2 = currValue;
    }
  }
  check_messages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.messages = currValue;
      this._expr_3 = currValue;
    }
  }
  check_required(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.required = currValue;
      this._expr_4 = currValue;
    }
  }
  check_disabled(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.disabled = currValue;
      this._expr_5 = currValue;
    }
  }
  check_model(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.model = currValue;
      this._expr_6 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.modelChange.subscribe(_eventHandler.bind(view,'modelChange'))); }
  }
}
var renderType_SaraSelectComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SaraSelectComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SaraSelectComponent>;
  _SaraSelectComponent_0_3:Wrapper_SaraSelectComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraSelectComponent_Host0,renderType_SaraSelectComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'sara-select',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SaraSelectComponent0(this.viewUtils,this,0,this._el_0);
    this._SaraSelectComponent_0_3 = new Wrapper_SaraSelectComponent();
    this.compView_0.create(this._SaraSelectComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SaraSelectComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SaraSelectComponent) && (0 === requestNodeIndex))) { return this._SaraSelectComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SaraSelectComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SaraSelectComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SaraSelectComponentNgFactory:import8.ComponentFactory<import0.SaraSelectComponent> = new import8.ComponentFactory<import0.SaraSelectComponent>('sara-select',View_SaraSelectComponent_Host0,import0.SaraSelectComponent);
const styles_SaraSelectComponent:any[] = ([] as any[]);
class View_SaraSelectComponent1 extends import2.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import9.Wrapper_NgClass;
  _text_1:any;
  _map_3:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import11.ViewContainer) {
    super(View_SaraSelectComponent1,renderType_SaraSelectComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'required-field': p0};
    });
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md'),(null as any));
    this._NgClass_0_3 = new import9.Wrapper_NgClass(this.parentView.parentView.injectorGet(import12.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import13.KeyValueDiffers,this.parentView.parentIndex),new import14.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import15.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = 'eva-label-form eva-3-label-form -md';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_3(this.parentView.context.required);
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.parentView.context.messages.name)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SaraSelectComponent2 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import17.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import18.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import11.ViewContainer) {
    super(View_SaraSelectComponent2,renderType_SaraSelectComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import17.Wrapper_NgSelectOption(new import14.ElementRef(this._el_0),this.renderer,(<View_SaraSelectComponent0>this.parentView)._SelectControlValueAccessor_8_3.context);
    this._NgSelectMultipleOption_0_4 = new import18.Wrapper_NgSelectMultipleOption(new import14.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import15.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import20.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = this.parentView.context.default.id;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.parentView.context.default.id;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.parentView.context.default.text)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SaraSelectComponent3 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import17.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import18.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  _pipe_translate_0:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import11.ViewContainer) {
    super(View_SaraSelectComponent3,renderType_SaraSelectComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import17.Wrapper_NgSelectOption(new import14.ElementRef(this._el_0),this.renderer,(<View_SaraSelectComponent0>this.parentView)._SelectControlValueAccessor_8_3.context);
    this._NgSelectMultipleOption_0_4 = new import18.Wrapper_NgSelectMultipleOption(new import14.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import15.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import20.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.$implicit.id;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit.id;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:boolean = (!this.parentView.context.default.active && (this.parentView.context.model === this.context.$implicit.id));
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setElementProperty(this._el_0,'selected',currVal_4);
      this._expr_4 = currVal_4;
    }
    valUnwrapper.reset();
    const currVal_5:any = import3.inlineInterpolate(1,'',(this.parentView.context.isNumber(this.context.$implicit.value)? this.context.$implicit.value: valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.value))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_1,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_SaraSelectComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SaraSelectComponent,{});
export class View_SaraSelectComponent0 extends import2.AppView<import0.SaraSelectComponent> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import11.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _SelectControlValueAccessor_8_3:import17.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_8_4:any[];
  _NgModel_8_5:import22.Wrapper_NgModel;
  _NgControl_8_6:any;
  _NgControlStatus_8_7:import23.Wrapper_NgControlStatus;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _vc_10:import11.ViewContainer;
  _TemplateRef_10_5:any;
  _NgIf_10_6:import21.Wrapper_NgIf;
  _text_11:any;
  _anchor_12:any;
  /*private*/ _vc_12:import11.ViewContainer;
  _TemplateRef_12_5:any;
  _NgFor_12_6:import24.Wrapper_NgFor;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  /*private*/ _expr_35:any;
  /*private*/ _expr_36:any;
  /*private*/ _expr_37:any;
  _pipe_translate_0:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraSelectComponent0,renderType_SaraSelectComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_35 = import1.UNINITIALIZED;
    this._expr_36 = import1.UNINITIALIZED;
    this._expr_37 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import11.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import25.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-select -md '),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'select',new import3.InlineArray2(2,'class','select-tag'),(null as any));
    this._SelectControlValueAccessor_8_3 = new import17.Wrapper_SelectControlValueAccessor(this.renderer,new import14.ElementRef(this._el_8));
    this._NG_VALUE_ACCESSOR_8_4 = [this._SelectControlValueAccessor_8_3.context];
    this._NgModel_8_5 = new import22.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_8_4);
    this._NgControl_8_6 = this._NgModel_8_5.context;
    this._NgControlStatus_8_7 = new import23.Wrapper_NgControlStatus(this._NgControl_8_6);
    this._text_9 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._vc_10 = new import11.ViewContainer(10,8,this,this._anchor_10);
    this._TemplateRef_10_5 = new import25.TemplateRef_(this,10,this._anchor_10);
    this._NgIf_10_6 = new import21.Wrapper_NgIf(this._vc_10.vcRef,this._TemplateRef_10_5);
    this._text_11 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._anchor_12 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._vc_12 = new import11.ViewContainer(12,8,this,this._anchor_12);
    this._TemplateRef_12_5 = new import25.TemplateRef_(this,12,this._anchor_12);
    this._NgFor_12_6 = new import24.Wrapper_NgFor(this._vc_12.vcRef,this._TemplateRef_12_5,this.parentView.injectorGet(import12.IterableDiffers,this.parentIndex),this.ref);
    this._text_13 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_6,'span',new import3.InlineArray2(2,'class','info-msg'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_20 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_8,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_8));
    this._NgModel_8_5.subscribe(this,this.eventHandler(this.handleEvent_8),true);
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import15.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._anchor_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import26.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import25.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import26.NgIf) && (10 === requestNodeIndex))) { return this._NgIf_10_6.context; }
    if (((token === import25.TemplateRef) && (12 === requestNodeIndex))) { return this._TemplateRef_12_5; }
    if (((token === import27.NgFor) && (12 === requestNodeIndex))) { return this._NgFor_12_6.context; }
    if (((token === import19.SelectControlValueAccessor) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._SelectControlValueAccessor_8_3.context; }
    if (((token === import28.NG_VALUE_ACCESSOR) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._NG_VALUE_ACCESSOR_8_4; }
    if (((token === import29.NgModel) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._NgModel_8_5.context; }
    if (((token === import30.NgControl) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._NgControl_8_6; }
    if (((token === import31.NgControlStatus) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._NgControlStatus_8_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = this.context.messages.name;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._SelectControlValueAccessor_8_3.ngDoCheck(this,this._el_8,throwOnChange);
    const currVal_8_1_0:any = import3.inlineInterpolate(1,'',this.context.name,'');
    this._NgModel_8_5.check_name(currVal_8_1_0,throwOnChange,false);
    const currVal_8_1_1:any = this.context.disabled;
    this._NgModel_8_5.check_isDisabled(currVal_8_1_1,throwOnChange,false);
    const currVal_8_1_2:any = this.context.model;
    this._NgModel_8_5.check_model(currVal_8_1_2,throwOnChange,false);
    this._NgModel_8_5.ngDoCheck(this,this._el_8,throwOnChange);
    this._NgControlStatus_8_7.ngDoCheck(this,this._el_8,throwOnChange);
    const currVal_10_0_0:any = this.context.default.active;
    this._NgIf_10_6.check_ngIf(currVal_10_0_0,throwOnChange,false);
    this._NgIf_10_6.ngDoCheck(this,this._anchor_10,throwOnChange);
    const currVal_12_0_0:any = this.context.messages.itemList;
    this._NgFor_12_6.check_ngForOf(currVal_12_0_0,throwOnChange,false);
    this._NgFor_12_6.ngDoCheck(this,this._anchor_12,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_10.detectChangesInNestedViews(throwOnChange);
    this._vc_12.detectChangesInNestedViews(throwOnChange);
    const currVal_35:any = import3.inlineInterpolate(1,'reset-styles eva-3-input -md -validate -validate-sm ',((this.context.error == null)? (null as any): this.context.error.cssClass),' -top-right');
    if (import3.checkBinding(throwOnChange,this._expr_35,currVal_35)) {
      this.renderer.setElementProperty(this._el_0,'className',currVal_35);
      this._expr_35 = currVal_35;
    }
    const currVal_36:any = import3.inlineInterpolate(1,'',this.context.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_36,currVal_36)) {
      this.renderer.setElementAttribute(this._el_8,'name',((currVal_36 == null)? (null as any): currVal_36.toString()));
      this._expr_36 = currVal_36;
    }
    this._NgControlStatus_8_7.checkHost(this,this,this._el_8,throwOnChange);
    valUnwrapper.reset();
    const currVal_37:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(((this.context.error == null)? (null as any): this.context.error.message))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_37,currVal_37))) {
      this.renderer.setText(this._text_16,currVal_37);
      this._expr_37 = currVal_37;
    }
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_10.destroyNestedViews();
    this._vc_12.destroyNestedViews();
    this._NgModel_8_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_SaraSelectComponent1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 10)) { return new View_SaraSelectComponent2(this.viewUtils,this,10,this._anchor_10,this._vc_10); }
    if ((nodeIndex == 12)) { return new View_SaraSelectComponent3(this.viewUtils,this,12,this._anchor_12,this._vc_12); }
    return (null as any);
  }
  handleEvent_8(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_8_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.model = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/sara-select/sara-select.component.ngfactory.ts